<script lang="ts">
import { getContext } from 'svelte';
import { page } from '$app/state';
import { ERoutes } from '../../../config/enums.js';
import { isContactOpen, isMenuOpen } from '../../../utils/store.js';
import LinkList from '../LinkList/LinkList.svelte';

interface MenuPage {
    url?: string;
    primaryTitle?: string;
}

interface NavLink {
    to: string;
    text: string;
    active: boolean;
    onClick: () => void;
}

const menuPages = getContext<MenuPage[] | undefined>('menuPages') ?? [];

const isUrlActive = (currentUrl: string, thisItemUrl: string) => {
    return currentUrl?.includes(thisItemUrl) ?? false;
};

let links: NavLink[] = $state([]);

let currentUrl = page?.url?.pathname;

const updateLinks = (currentUrlArg: string | undefined) => {
    links = menuPages.map((pageItem: MenuPage) => ({
        to: pageItem.url ?? '',
        text: pageItem.primaryTitle ?? '',
        active: isUrlActive(currentUrlArg ?? '', pageItem.url ?? ''),
        onClick: () => {
            isMenuOpen.set(false);
        },
    }));

    links.push({
        text: 'Contact',
        to: ERoutes.Contact,
        active: isUrlActive(currentUrlArg ?? '', ERoutes.Contact),
        onClick: () => {
            isMenuOpen.set(false);
            isContactOpen.set(true);
        },
    });
};

updateLinks(page?.url?.pathname);

$effect(() => {
    if (currentUrl !== page?.url?.pathname) {
        updateLinks(page?.url?.pathname);
        currentUrl = page?.url?.pathname;
    }
});
</script>

<nav class="nav">
    <LinkList items={links} />
</nav>

<style lang="scss">
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .nav {
        @include typography.nav-primary;

        :global(.linklist) {
            margin: 0 0 4rem;

            @include mq($from: tablet) {
                display: flex;
                gap: clamp(0.5rem, 2.5vw, 4rem);
                margin: 0;
            }
        }

        :global(.linklist__item) {
            position: relative;
            @include mq($until: tablet) {
                margin-bottom: 2rem;
            }
        }

        :global(.linklist__item:has(a[href*='contact'])) {
            @include mq($from: tablet) {
                display: none;
            }
        }

        :global(.linklist__item:last-child) {
            margin-bottom: 0;
        }

        :global(.linklist__item a:after) {
            @include mq($from: tablet) {
                background-color: #fff;
                bottom: -0.1rem;
                content: '';
                height: 0.1rem;
                left: 0;
                position: absolute;
                transform: scaleX(0);
                transition: transform 0.3s;
                width: 100%; /* 100% width pushes slightly over rhs edge */
            }
        }

        :global(.linklist__item a:hover:after) {
            @include mq($from: tablet) {
                transform: scaleX(1);
            }
        }

        :global(.linklist__item.item--active a:after) {
            @include mq($from: tablet) {
                transform: scaleX(1);
            }
        }
    }

    :global(.header--alt-nav-colour .nav .linklist__item.item--active a:after) {
        @include mq($from: tablet) {
            background-color: #000;
        }
    }

    :global(.header--alt-nav-colour .nav .linklist__item a:hover:after) {
        @include mq($from: tablet) {
            background-color: #000;
        }
    }

    :global(.header--is-stuck .nav .linklist__item.item--active a:after) {
        @include mq($from: tablet) {
            background-color: #000;
        }
    }

    :global(.header--is-stuck .nav .linklist__item a:hover:after) {
        @include mq($from: tablet) {
            background-color: #000;
        }
    }
</style>
